import { PROSPECTS_ROUTES } from '../../constants/_routes'
import prospectsTypes from '../../constants/prospectsTypes'
import { axios } from '../../services'

// INDEX
const prospects_export_request = () => {
  return {
    type: prospectsTypes.export.request
  }
}

const prospects_export_success = () => {
  return {
    type: prospectsTypes.export.success
  }
}

const prospects_export_failure = (messages) => {
  return {
    type: prospectsTypes.export.failure,
    payload: messages
  }
}

const prospects_xlsx = (filters={}, sort="", order="") => {
  return function (dispatch) {
    // Before Request
    dispatch(prospects_export_request())
    document.body.classList.add('instalevel-fetching-data')

    axios.get(
      `${PROSPECTS_ROUTES.index}.xlsx`,
      {
        params: {
          sort: sort,
          order: order,
          filters: filters
        },
        responseType: 'blob'
      }
    ).then( response => {
      // success
      const filename = 'prospects.xlsx'
      const blob = URL.createObjectURL(response.data, "mitsos")
      let fileLink = document.createElement('a')
      document.body.appendChild(fileLink);
      fileLink.style="display: none"
      fileLink.href = blob
      fileLink.download = filename
      fileLink.click();
      URL.revokeObjectURL(blob)
      dispatch( prospects_export_success() )
      document.body.classList.remove('instalevel-fetching-data')
    }).catch( error=> {
      // failure
      document.body.classList.remove('instalevel-fetching-data')
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else {
        errors = ["Error fetching xlsx file."]
      }
      // dispatch( try_force_logoff(error.response.data) )
      dispatch( prospects_export_failure(errors))
    })
  }

}

export {
  prospects_xlsx
}



// WEBPACK FOOTER //
// ./src/js/actions/prospects/getxlsx.js